import { render, staticRenderFns } from "./tgbtn-rq.vue?vue&type=template&id=7d549e66&scoped=true"
import script from "./tgbtn-rq.vue?vue&type=script&lang=js"
export * from "./tgbtn-rq.vue?vue&type=script&lang=js"
import style0 from "./tgbtn-rq.vue?vue&type=style&index=0&id=7d549e66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d549e66",
  null
  
)

export default component.exports